export default {
    Aruba: "Aruba",
    Bolivia: "Bolívia",
    Brazil: "Brasil",
    Colombia: "Colômbia",
    "Dominican Republic": "República Dominicana",
    Ecuador: "Equador",
    England: "Inglaterra",
    "French Guiana": "Guiana Francesa",
    Mexico: "México",
    Nicaragua: "Nicarágua",
    Panama: "Panamá",
    Paraguay: "Paraguai",
    "Puerto Rico": "Porto Rico",
    "Saint Martin": "Saint Martin",
    "Trinidad and Tobago": "Trinidad e Tobago",
    "United States": "Estados Unidos",
    Uruguay: "Uruguai",
    Venezuela: "Venezuela"
}
